import { render, staticRenderFns } from "./ProdutoCotaDepartamentoForm.vue?vue&type=template&id=3c777ef5"
import script from "./ProdutoCotaDepartamentoForm.vue?vue&type=script&lang=js"
export * from "./ProdutoCotaDepartamentoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports